import { get } from "../../helpers/apiWrapper";

export const getAllCountries = async (params) => {
  const config = {
    params: params,
  };
  return await get(`/countries`, config);
};